export enum ViewerAction {

  NONE = 'NONE',
  OPEN = 'OPEN',
  CLOSE = 'CLOSE',
  SEND = 'SEND',
  SENT = 'SENT',
}
